/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".attention-form[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;font-size:1.25vw}@media (max-width:1279px){.attention-form[_ngcontent-%COMP%]{font-size:22px}}.attention-form[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]:last-child{margin:10px 0 0}"];
export { styles as styles };
